import VueResource from 'vue-resource';
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCode, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faFontAwesome, faFacebookF, faSuperpowers, faHubspot, faLine,
} from '@fortawesome/free-brands-svg-icons';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAnalytics from 'vue-analytics';
import VeLine from 'v-charts/lib/line.common';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(VueResource);
Vue.use(axios);

Vue.use(VueAnalytics, {
  id: 'UA-175494231-1',
  router,
  autoTracking: {
    pageviewOnLoad: false,
  },
});

library.add(faCode, faGlobe);
library.add(faFontAwesome, faFacebookF, faSuperpowers, faHubspot, faLine);

Vue.use(ElementUI);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component(VeLine.name, VeLine);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
